import { render, staticRenderFns } from "./ScoringCountsFilter.vue?vue&type=template&id=223225f6"
import script from "./ScoringCountsFilter.js?vue&type=script&lang=js&external"
export * from "./ScoringCountsFilter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports